import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


export function getViewReviewsOverview(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/reviews-overview`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewReviewsConnections(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/reviews-connections`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathViewReviewsConfigShforms() {
  return `view/extensions/reviews-config-shforms`;
}

export function getViewReviewsConfigShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewReviewsConfigShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


function pathViewReviewsEmailsEditor() {
  return `view/extensions/reviews-emails-editor`;
}

export function getViewReviewsEmailsEditor(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewReviewsEmailsEditor(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathReviewsConfig() {
  return `extensions/reviews-config`;
}

export function createReviewsConfig(successCallback, errorCallback, data) {
  postAuth({
    "path": pathReviewsConfig(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchReviewsConfig(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathReviewsConfig(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export const URL_EXTENSION_REVIEWS_LOGO_MEDIA = `/${constants.API_VERSION}/extensions/reviews/logo-media`;

export function getViewManageReviewsEmails(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/extensions/manage-reviews-emails`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postResendReviewsEmailRecipients(successCallback, errorCallback, recipientId) {
  postAuth({
    "path": `extensions/reviews-email-recipients/${recipientId}/resend`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
  });
}


export function postSendReviewRequestForPastPurchases(successCallback, errorCallback, data) {
  postAuth({
    "path": `extensions/send-review-request-for-past-purchases`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

